module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "appendToBody": true,
      "ariaLabel": _vm.headerTitle
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "sds text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "sds__header",
    style: ({
      backgroundColor: _vm.color
    })
  }, [_c('h2', [_vm._v(_vm._s(_vm.headerTitle))]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle sds__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sds__body"
  }, [_c('div', {
    staticClass: "sds__form"
  }, [_c('div', {
    staticClass: "sds__group"
  }, [_c('label', {
    staticClass: "sds__label"
  }, [_vm._v("Brikkens navn")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    ref: "input_name",
    staticClass: "sds__input",
    class: {
      'sds__input--error': _vm.nameError
    },
    attrs: {
      "type": "text",
      "placeholder": "Eks. Motionsdag"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "keyup": function($event) {
        _vm.nameError = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.nameError) ? _c('p', {
    staticClass: "sds__error"
  }, [_vm._v("Brikken skal have et navn")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "sds__group"
  }, [_c('label', {
    staticClass: "sds__label"
  }, [_vm._v("Klokketimer i skoleåret")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.hours),
      expression: "hours",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "sds__input",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.hours)
    },
    on: {
      "focus": function($event) {
        return _vm.selectAllOnFocus($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hours = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sds__group"
  }, [_c('label', {
    staticClass: "sds__label"
  }, [_vm._v("Vælg farve")]), _vm._v(" "), _c('ColorPicker', {
    attrs: {
      "initialColor": _vm.color
    },
    on: {
      "changedColor": function($event) {
        _vm.color = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sds__group"
  }, [_c('label', {
    staticClass: "sds__label"
  }, [_vm._v("Vælg briktype")]), _vm._v(" "), _c('SubjectTypePicker', {
    attrs: {
      "calendarType": "klass",
      "subjectType": _vm.subjectType
    },
    on: {
      "change": function($event) {
        _vm.subjectType = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "sds__classes"
  }, [_c('div', {
    staticClass: "sds__classes__top"
  }, [_c('div', {
    staticClass: "sds__classes__top__left"
  }, [_c('Tabs', {
    staticClass: "sds__tabs",
    attrs: {
      "tabs": _vm.modeTabs,
      "selected": _vm.mode
    },
    on: {
      "select": _vm.setMode
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sds__classes__head"
  }, [(_vm.mode === 'per_class') ? _c('button', {
    staticClass: "do-bttn do-bttn--small",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addRow
    }
  }, [_vm._v("Tilføj brik")]) : _vm._e()])]), _vm._v(" "), (_vm.rowsError) ? _c('p', {
    staticClass: "sds__error"
  }, [_vm._v("Vælg mindst én klasse")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sds__table"
  }, [(_vm.rows.length > 0 || _vm.existingSubjects.length > 0) ? _c('div', {
    staticClass: "sds__table__head"
  }, [_c('div', {
    staticClass: "sds__col sds__col--title"
  }, [_vm._v("Brik")]), _vm._v(" "), _c('div', {
    staticClass: "sds__col sds__col--class"
  }, [_vm._v("Klasser")]), _vm._v(" "), _c('div', {
    staticClass: "sds__col sds__col--teachers"
  }, [_vm._v("Undervisere")]), _vm._v(" "), _c('div', {
    staticClass: "sds__col sds__col--hours"
  }, [_vm._v("Timer")]), _vm._v(" "), _c('div', {
    staticClass: "sds__col sds__col--remove"
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.existingSubjects), function(subject) {
    return _c('div', {
      key: 'ex-' + subject.id,
      staticClass: "sds__row sds__row--existing"
    }, [_c('div', {
      staticClass: "sds__col sds__col--title"
    }, [_c('span', {
      staticClass: "sds__pill",
      style: ({
        backgroundColor: subject.color
      })
    }, [_vm._v(_vm._s(subject.name))])]), _vm._v(" "), _c('div', {
      staticClass: "sds__col sds__col--class"
    }, [_vm._v(_vm._s(_vm.existingKlasseNames(subject) || '–'))]), _vm._v(" "), _c('div', {
      staticClass: "sds__col sds__col--teachers"
    }, [_vm._v(_vm._s(_vm.existingTeacherNames(subject) || '–'))]), _vm._v(" "), _c('div', {
      staticClass: "sds__col sds__col--hours"
    }, [_vm._v(_vm._s(_vm.formatHours(subject.hours)))]), _vm._v(" "), _c('div', {
      staticClass: "sds__col sds__col--remove"
    }, [_c('span', {
      staticClass: "sds__row__badge"
    }, [_vm._v("Oprettet")])])])
  }), _vm._v(" "), _vm._l((_vm.rows), function(row) {
    return _c('div', {
      key: row.uid,
      staticClass: "sds__row",
      class: {
        'sds__row--empty': row.klassIds.length === 0,
        'sds__row--error': row.klassError
      }
    }, [_c('div', {
      staticClass: "sds__col sds__col--title"
    }, [_c('span', {
      staticClass: "sds__pill",
      style: ({
        backgroundColor: _vm.color
      })
    }, [_vm._v(_vm._s(_vm.name || 'Brik'))])]), _vm._v(" "), _c('div', {
      staticClass: "sds__col sds__col--class"
    }, [_c('DSelectCalendarIds', {
      key: 'k-' + row.uid,
      attrs: {
        "itemType": "klass",
        "showTags": false,
        "preSelectedItems": row.klassIds,
        "showCreateButton": false
      },
      on: {
        "update": function($event) {
          return _vm.setKlasses(row, $event)
        }
      }
    }), _vm._v(" "), (row.klassError) ? _c('p', {
      staticClass: "sds__error sds__error--row"
    }, [_vm._v("Brikken skal have minimum en klasse")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "sds__col sds__col--teachers"
    }, [_c('DSelectCalendarIds', {
      key: 't-' + row.uid,
      attrs: {
        "itemType": "user",
        "showTags": true,
        "preSelectedItems": row.teacherIds,
        "showCreateButton": false
      },
      on: {
        "update": function($event) {
          return _vm.setTeachers(row, $event)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "sds__col sds__col--hours"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (row.hours),
        expression: "row.hours",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "sds__input",
      attrs: {
        "type": "number",
        "min": "0"
      },
      domProps: {
        "value": (row.hours)
      },
      on: {
        "focus": function($event) {
          return _vm.selectAllOnFocus($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "hours", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "sds__col sds__col--remove"
    }, [(_vm.mode === 'per_class') ? _c('div', {
      staticClass: "icon__bg-circle sds__row__remove",
      attrs: {
        "role": "button",
        "tabindex": "0",
        "aria-label": "Fjern række"
      },
      on: {
        "click": function($event) {
          return _vm.removeRow(row)
        },
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.removeRow(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon-bin"
    })]) : _vm._e()])])
  }), _vm._v(" "), (_vm.rows.length === 0) ? _c('p', {
    staticClass: "sds__hint"
  }, [_vm._v("Ingen klasser tilføjet endnu.")]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "sds__footer"
  }, [_c('div', {
    staticClass: "sds__footer__warnings"
  }, [(_vm.duplicateKlassNames.length > 0) ? _c('p', {
    staticClass: "sds__footer__warning"
  }, [_c('span', {
    staticClass: "icon-warning"
  }), _vm._v("\n          Flere brikker har samme klasse: " + _vm._s(_vm.duplicateKlassNames.join(', ')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.missingKlassNames.length > 0) ? _c('p', {
    staticClass: "sds__footer__warning"
  }, [_c('span', {
    staticClass: "icon-warning"
  }), _vm._v("\n          Mangler klasse: " + _vm._s(_vm.missingKlassNames.join(', ')) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn",
    attrs: {
      "disabled": _vm.isSaving
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Annuller")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--disabled': _vm.isSaving,
      'do-bttn--submit--loading': _vm.isSaving
    },
    on: {
      "click": _vm.create
    }
  }, [_vm._v("Opret " + _vm._s(_vm.brikLabel))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7eddef3d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SpecialDays/SpecialDaySubjectsModal.vue
// module id = 2039
// module chunks = 1